/**
 * 맥스매치 Lite 상세 상단 정보.
 * 레거시는 목록→상세 query로 전달한다. 신규는 search + sessionStorage로 동일 데이터를 보장한다.
 */
export type MaxMatchMiniHeaderPayload = {
  email: string;
  companyName: string;
  createdAt: string;
  maxMatchCreatedAt: string;
  prescriptionYearMonth: string;
  status: string;
};

const storageKey = (summaryId: number) =>
  `ruda:max-match-mini-header:${summaryId}`;

export const EMPTY_MINI_HEADER: MaxMatchMiniHeaderPayload = {
  email: '',
  companyName: '',
  createdAt: '',
  maxMatchCreatedAt: '',
  prescriptionYearMonth: '',
  status: '',
};

export const saveMaxMatchMiniHeader = (
  summaryId: number,
  payload: MaxMatchMiniHeaderPayload,
): void => {
  try {
    sessionStorage.setItem(storageKey(summaryId), JSON.stringify(payload));
  } catch {
    // private mode 등 — search 전달에 의존
  }
};

export const loadMaxMatchMiniHeader = (
  summaryId: number,
): MaxMatchMiniHeaderPayload | null => {
  if (!summaryId) return null;
  try {
    const raw = sessionStorage.getItem(storageKey(summaryId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<MaxMatchMiniHeaderPayload>;
    return {
      email: String(parsed.email ?? ''),
      companyName: String(parsed.companyName ?? ''),
      createdAt: String(parsed.createdAt ?? ''),
      maxMatchCreatedAt: String(parsed.maxMatchCreatedAt ?? ''),
      prescriptionYearMonth: String(parsed.prescriptionYearMonth ?? ''),
      status: String(parsed.status ?? ''),
    };
  } catch {
    return null;
  }
};

/** TanStack search / query 값 → 문자열 (배열이면 첫 값) */
export const coerceSearchString = (value: unknown): string => {
  if (typeof value === 'string') return value;
  if (Array.isArray(value) && typeof value[0] === 'string') return value[0];
  if (value == null) return '';
  return String(value);
};

export const pickNonEmpty = (
  ...candidates: Array<string | null | undefined>
): string => {
  for (const candidate of candidates) {
    if (candidate != null && String(candidate).trim() !== '') {
      return String(candidate);
    }
  }
  return '';
};
